import React from "react";
import { Table, TableHead, TableRow, TableCell, TableBody, Paper, TableContainer, IconButton, Chip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";

interface Props {
  rows: any[];
  onView: (row: any) => void;
  onReturn: (row: any) => void;
  onCancel: (row: any) => void;
  onPrint: (row: any) => void;
}

const statusColor = (s: string) => {
  switch ((s || "").toUpperCase()) {
    case "ISSUED":
      return "warning";
    case "RETURNED":
      return "success";
    case "OVERDUE":
      return "error";
    case "CANCELLED":
      return "default";
    default:
      return "default";
  }
};

const GatePassTable: React.FC<Props> = ({ rows, onView, onReturn, onCancel, onPrint }) => {
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Pass No</TableCell>
            <TableCell>Student Name</TableCell>
            <TableCell>Admission No</TableCell>
            <TableCell>Class</TableCell>
            <TableCell>Section</TableCell>
            <TableCell>Reason</TableCell>
            <TableCell>Exit Time</TableCell>
            <TableCell>Expected Return</TableCell>
            <TableCell>Actual Return</TableCell>
            <TableCell>Status</TableCell>
            <TableCell align="right">Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((r) => (
            <TableRow key={r.id}>
              <TableCell>{r.passNumber}</TableCell>
              <TableCell>{r.student ? `${r.student.firstName} ${r.student.lastName}` : "-"}</TableCell>
              <TableCell>{r.student?.admissionNumber}</TableCell>
              <TableCell>{r.student?.class?.name || "-"}</TableCell>
              <TableCell>{r.student?.section?.name || "-"}</TableCell>
              <TableCell>{r.reason}</TableCell>
              <TableCell>{new Date(r.exitTime).toLocaleString()}</TableCell>
              <TableCell>{r.expectedReturnTime ? new Date(r.expectedReturnTime).toLocaleString() : "-"}</TableCell>
              <TableCell>{r.actualReturnTime ? new Date(r.actualReturnTime).toLocaleString() : "-"}</TableCell>
              <TableCell>
                <Chip label={r.status} color={statusColor(r.status) as any} size="small" />
              </TableCell>
              <TableCell align="right">
                <IconButton size="small" onClick={() => onView(r)} title="View">
                  <VisibilityIcon />
                </IconButton>
                <IconButton size="small" onClick={() => onReturn(r)} title="Mark Returned" disabled={r.status !== "ISSUED"}>
                  <CheckIcon />
                </IconButton>
                <IconButton size="small" onClick={() => onCancel(r)} title="Cancel" disabled={r.status !== "ISSUED"}>
                  <CloseIcon />
                </IconButton>
                <IconButton size="small" onClick={() => onPrint(r)} title="Print">
                  <PrintIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
          {rows.length === 0 && (
            <TableRow>
              <TableCell colSpan={11} align="center">
                No gate passes
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default GatePassTable;
